<template>
  <Slider
    :value="value"
    :ticks-labels="ticksLabels"
  />
</template>

<script>
import Slider from '@/components/atoms/Slider'

export default {
  name: 'WorkingStanceSlider',
  components: {
    Slider,
  },
  props: {
    value: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ticksLabels () {
      return [
        '少数のプロジェクトに深く携わる',
        '',
        '',
        '',
        '多くのプロジェクトに広く携わる',
      ]
    }
  },
}
</script>
